import type { Warning } from './types.js';

const informationalNotes = new Set(['PREVIOUS_CLOSING_PRICE', 'BTC_FEE_V1_COMPATIBILITY', 'BTC_HISTORICAL_FEE_COMPATIBILITY']);

/** Retain source diagnostics without showing routine/convention notices in reports. */
export function reportFindings(warnings: Warning[]): Warning[] {
  return warnings.filter(warning => warning.severity === 'error' || !informationalNotes.has(warning.code));
}
